import {Snippet, SnippetPosition} from '@mintdata-wsp/common/state/DataState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {DataLine, DataLineColorType} from '@mintdata-wsp/wsp/ui/components/dataline/DataLine';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {MenuItem} from '@mintdata-wsp/wsp/ui/components/menus/MenuItem';
import {EditSnippet} from '@mintdata-wsp/wsp/ui/views/workspace/settings/organization/snippets/EditSnippet';
import {Checkbox, CheckboxStyle} from '@mintdata/mint-kit/impl/properties/components/checkbox/Checkbox';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./SnippetCard.less');
const cx = classnames.bind(styles);

export interface SnippetCardProps
{
    snippet:Snippet;
    isNew:boolean;
}

export const SnippetPositionTitle = {
    [SnippetPosition.HEAD_START]: '\<HEAD\> start',
    [SnippetPosition.HEAD_END]: '\<HEAD\> end',
    [SnippetPosition.BODY_START]: '\<BODY\> start',
    [SnippetPosition.BODY_END]: '\<BODY\> end',
};

@observer
export class SnippetCard extends React.Component<SnippetCardProps, any>
{
    private _menuItems:MenuItem[] = this._computeMenu();

    @observable
    private _isEdit:boolean = false;

    render()
    {
        const {snippet, isNew: isNewLine} = this.props;

        const {name, enabled} = snippet;

        const colorType = enabled ? DataLineColorType.Blue : DataLineColorType.Gray;

        const positionText = SnippetPositionTitle[snippet.embedPosition];

        return (
            <DataLine
                menuItems={this._isEdit ? null : this._menuItems}
                isNewLine={isNewLine}
                colorType={colorType}
                className={cx('snippetCard')}
            >
                {
                    !this._isEdit &&
                    <Row className={cx('viewMode')}>

                        <Row className={styles.desktopRow}>

                            <div className={cx('name')}>
                                {name}
                            </div>

                            <div className={cx('position')}>
                                {positionText}
                            </div>

                        </Row>

                        <Checkbox
                            style={CheckboxStyle.Toggler}
                            isChecked={enabled}
                            onClick={(e) => this._onClickCheckbox(e, snippet)}
                        />

                    </Row>
                }
                {
                    this._isEdit &&
                    <EditSnippet
                        className={cx('editMode')}
                        snippet={snippet}
                        buttonTitle={'Save'}
                        onClose={this._closeEdit}
                        onChange={this._onChangeSnippet}
                    />
                }
            </DataLine>
        );
    }

    @action.bound
    private _onClickCheckbox(event:React.MouseEvent<HTMLElement>, snippet:Snippet)
    {
        const newSnippet = {
            ...snippet,
            enabled: !snippet.enabled
        };

        controllers.data.snippets.updateSnippet(snippet, newSnippet)
            .catch(() =>
            {
            });
    }

    @bind
    private _computeMenu():MenuItem[]
    {
        return [
            MenuItem.simple('edit', 'Edit', this._menuItemEditSnippet),
            MenuItem.separator(),
            MenuItem.simple('delete', 'Delete', this._menuItemDeleteSnippet),
        ];
    }

    @action.bound
    private _menuItemEditSnippet()
    {
        this._isEdit = true;
    }

    @action.bound
    private _closeEdit()
    {
        this._isEdit = false;
    }

    @bind
    private _onChangeSnippet(newSnippet:Snippet)
    {
        const {snippet} = this.props;

        if( !newSnippet.name || newSnippet.name.trim().length === 0 ) return;

        controllers.data.snippets.updateSnippet(snippet, newSnippet)
            .then(action(() =>
            {
                this._isEdit = false;
            }))
            .catch(() =>
            {
            });
    }

    @bind
    private _menuItemDeleteSnippet()
    {
        const {snippet} = this.props;

        controllers.ui.dialogs.showDangerConfirm(
            `Remove Snippet "${snippet.name}"?`,
            'Snippet will be deleted. This operation cannot be undone.',
            () =>
            {
                controllers.data.snippets.deleteSnippet(snippet)
                    .then(() =>
                    {
                        controllers.ui.dialogs.hideConfirmDialog();
                    })
                    .catch(() =>
                    {
                    });
            },
            ['Cancel', 'REMOVE']
        );
    }
}





